<template>
  <div id="orgList">
    <Tree :data="organizationList" id="orgTree" @on-select-change="selectNode">

    </Tree>
  </div>
</template>

<script>
export default {
  name: 'orgList',
  props: {
    organizationList: {
      type: Array,
      required: true
    }
  },
  methods: {
    selectNode(node) {
      // 只允许获取单节点
      this.$emit('selectNode', node[0])
    }
  }
}
</script>

<style lang="less" scoped>

</style>
